'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_java$002eutil$002e$002dCollections$0024$002dUnmodifiable$002dIterator from "./java.util.-Collections$-Unmodifiable-Iterator.js";
var $p;
function $ct_ju_Collections$UnmodifiableCollection__ju_Collection__($thiz, inner) {
  $thiz.fv = inner;
  return $thiz;
}
export { $ct_ju_Collections$UnmodifiableCollection__ju_Collection__ as $ct_ju_Collections$UnmodifiableCollection__ju_Collection__ };
/** @constructor */
function $c_ju_Collections$UnmodifiableCollection() {
  this.fv = null;
}
export { $c_ju_Collections$UnmodifiableCollection as $c_ju_Collections$UnmodifiableCollection };
$p = $c_ju_Collections$UnmodifiableCollection.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_ju_Collections$UnmodifiableCollection;
/** @constructor */
function $h_ju_Collections$UnmodifiableCollection() {
}
export { $h_ju_Collections$UnmodifiableCollection as $h_ju_Collections$UnmodifiableCollection };
$h_ju_Collections$UnmodifiableCollection.prototype = $p;
$p.T = (function() {
  return this.fv.T();
});
$p.ae = (function(o) {
  return this.fv.ae(o);
});
$p.CF = (function(a) {
  return this.fv.CF(a);
});
$p.b = (function() {
  return this.fv.b();
});
$p.cV = (function() {
  return $j_java$002eutil$002e$002dCollections$0024$002dUnmodifiable$002dIterator.$ct_ju_Collections$UnmodifiableIterator__ju_Iterator__(new $j_java$002eutil$002e$002dCollections$0024$002dUnmodifiable$002dIterator.$c_ju_Collections$UnmodifiableIterator(), this.fv.cV());
});
$p.eP = (function(e) {
  throw $j_java$002elang$002e$002dObject.$ct_jl_UnsupportedOperationException__(new $j_java$002elang$002e$002dObject.$c_jl_UnsupportedOperationException());
});
